export default {
  name: 'advantage-card',
  props: {
    img: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      required: true
    }
  }
};